import React, { useState, useCallback, useEffect } from "react";
import axios from "axios";
import "../../css/PaginaNosotros/Pagenosotros.css"
import { Box, Container, Grid, CircularProgress } from '@mui/material';
import { useInView } from "react-intersection-observer";
import { motion } from "framer-motion";
/* imagenes */
import titulo from "../../Image/nosotros-hod-87.png"
import fondo from "../../Image/nosotros-hod-89.png"




export const NosotrosCard = () => {
 
 const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });
   const [loading, setLoading] = useState(false);
      const backendURL = process.env.REACT_APP_BACKEND_URL;
      const [icono, setIcono] = useState([]);
      const [info, setInfo] = useState([]);

       const fetchSliders = useCallback(async () => {
      setLoading(true)
      try {
        const response = await axios.get(`${backendURL}/api/portadajomefar/public`);
        setIcono(response.data.data);
        setLoading(false)
      } catch (error) {
        console.error("Error al obtener sliders:", error);
      }
    }, [backendURL]);
  

      const fetchinfo = useCallback(async () => {
      setLoading(true)
      try {
        const response = await axios.get(`${backendURL}/api/portada-jofemar/public`);
        setInfo(response.data[0]);
        setLoading(false)
      } catch (error) {
        console.error("Error al obtener sliders:", error);
      }
    }, [backendURL]);
  
    // Llamada inicial a sliders cuando hay token
    useEffect(() => {
  
      fetchSliders();
      fetchinfo();
  
    }, [fetchSliders, fetchinfo]);
  
    if (loading) {
      return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          <Box display="flex" flexDirection="column" alignItems="center">
            <CircularProgress size={80} thickness={6} /> {/* Hacemos el CircularProgress más grande */}
          </Box>
        </div>
      );
    }
 


  return (


    <section
      style={{
        backgroundImage: `url(${fondo})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        marginTop: '100px'
      }}
    >
      <Container maxWidth="lg" sx={{ padding: '100px 0px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }} >
        <Box className='imagenTituloNosotros'
        >
          <img src={titulo} alt='hod maquinas dispensadoras' title='hod maquinas dispensadoras' />
        </Box>

        <Grid container spacing={10} sx={{ marginBottom: '80px', justifyContent: 'center' }}>
          <Grid size={{ sm: 12, md: 4 }} sx={{
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'center',
            flexDirection: 'column',
            '@media (max-width:899px)': {
              alignItems: 'center',
            },
          }} >
            <Box sx={{
              display: 'flex',
              alignItems: 'flex-end',
              justifyContent: 'center',
              flexDirection: 'column',
              '@media (max-width:899px)': {
                flexDirection: 'row',
                alignItems: 'center'
              },
            }}>
              <h2 className='Jofemartitulo'>¿quién es</h2>
              <h2 className='Jofemardostitulo'> jofermar?</h2>
            </Box>

          </Grid>
          <Grid size={{ sm: 12, md: 8 }}>
            <Box sx={{
              '@media (max-width:899px)': {
                padding: '0px 50px'
              },
              '@media (max-width:550px)': {
                marginTop: '-40px'
              },
              '@media (max-width:500px)': {
                padding: '0px 20px'
              },

            }}>
              <h2 className='Jofemardescripcion'>{info.titulo}</h2>
              <h3 className='Jofemardescripciondos'>{info.subtitulo}</h3>
            </Box>
          </Grid>
        </Grid>


        <Grid container spacing={4} sx={{
          '@media (max-width:899px)': {
            padding: '0px 50px'
          },
          '@media (max-width:500px)': {
            padding: '0px 20px'
          },
        }}
          ref={ref}>

            {icono.map((item, index) => (
            <Grid size={{ xs: 12, sm: 6, md: 4 }} key={index} sx={{
              display: 'flex', alignItems: 'center', justifyContent: 'center', '@media (max-width:599px)': {
                margin: '30px'
              },
            }} r>  
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.2 }}

            >
                <Box
                  sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                  <Box className='imagenIconoNosotros'>
                   {item.imagen && (
                                                                <img
                                                                    src={`${backendURL}/${item.imagen}`}
                                                                    alt="Hod maquinas dispensadoras" title='"Hod maquinas dispensadoras'
                                                                    
                                                                />
                                                            )}
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', marginTop: '15px' }}>
                    <h2 className='TituloUnoNosotros'>{item.titulo1}</h2>
                    <h2 className='TituloDosNosotros'> {item.titulo2}</h2>
                  </Box>

                </Box>
              </motion.div>
            </Grid>
          ))}

        </Grid>


      </Container>
    </section>
  );
};
